module.exports = __webpack_public_path__ + "static/media/salesforcePlugHeader2x.fb847329.png";